/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Features_Sample_ConsultInputs */

const en_features_sample_consult = /** @type {(inputs: Features_Sample_ConsultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Consultation`)
};

const pl_features_sample_consult = /** @type {(inputs: Features_Sample_ConsultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konsultacja`)
};

/**
* | output |
* | --- |
* | "Consultation" |
*
* @param {Features_Sample_ConsultInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const features_sample_consult = /** @type {((inputs?: Features_Sample_ConsultInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Sample_ConsultInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_features_sample_consult(inputs)
	return en_features_sample_consult(inputs)
});